export default __webpack_public_path__ + "static/media/Homepage-PT.60d6850a.jpg";